import { render, staticRenderFns } from "./Ajuda.vue?vue&type=template&id=5b85adba&scoped=true"
import script from "./Ajuda.vue?vue&type=script&lang=js"
export * from "./Ajuda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b85adba",
  null
  
)

export default component.exports